/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Discount_Rule_PercentInputs */

const vi_discount_rule_percent = /** @type {(inputs: Discount_Rule_PercentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiết khấu (%)`)
};

/**

* @param {Discount_Rule_PercentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const discount_rule_percent = /** @type {((inputs?: Discount_Rule_PercentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Discount_Rule_PercentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_discount_rule_percent(inputs)
});